var _Loader;
import { useTranslation } from '@crehana/i18n';
import Loader from "../../../Loader";
import { cn } from "../../utils";
import locales from "../i18n";
import { TableBody, TableCell, TableRow } from "../table";
import { getFixedTableHeight } from "../utils/get-fixed-table-height";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TableLoading = function TableLoading(_ref) {
  var _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 9999 : _ref$columns,
    pageSize = _ref.pageSize;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var t = locales[languageCode];
  return /*#__PURE__*/_jsx(TableBody, {
    children: /*#__PURE__*/_jsx(TableRow, {
      className: "hover:tw-bg-inherit dark:hover:tw-bg-inherit",
      children: /*#__PURE__*/_jsx(TableCell, {
        colSpan: columns,
        className: cn('tw-text-center', pageSize > 10 && 'tw-py-28'),
        style: {
          height: pageSize <= 10 ? getFixedTableHeight(pageSize) : 'auto'
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.2",
          children: [_Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {
            size: "s"
          })), /*#__PURE__*/_jsx("p", {
            className: "tw-font-subtitle5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500",
            children: t.TABLE_STATE_LOADING_RESULTS
          })]
        })
      })
    })
  });
};